export enum CanonicalEnvironmentName {
  Dev = 'dev',
  Test = 'test',
  Prod = 'prod'
}
